<template>
  <div>
    <b-dropdown
      ref="propertiesDropdown"
      size="sm"
      variant="primary"
      text="Properties"
      class="select-properties-dropdown"
      menu-class="p-0"
    >
      <b-list-group>
        <b-list-group-item
          v-for="(property, index) in getProperties"
          :key="index"
        >
          <b-form-checkbox
            v-model="property.value"
            size="sm"
            @change="onChangeProperties(property)"
          >
            {{ property.text }}
          </b-form-checkbox>
        </b-list-group-item>
        <b-list-group-item

          class="d-flex justify-content-end"
        >
          <b-button
            v-if="selectedProperties.length"
            size="sm"
            class="mr-2"
            variant="outlined"
            @click.prevent.stop="resetProperties"
          >
            Reset
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            :disabled="!selectedProperties.length"
            @click="apply"
          >
            Apply
          </b-button>
        </b-list-group-item>
      </b-list-group>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    isColorSelector: {
      type: Boolean,
      default: true,
    },
    isFontSelector: {
      type: Boolean,
      default: true,
    },
    isAlignmentSelector: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      properties: [
        {
          text: 'Replace Text',
          key: 'text',
          targetKey: 'isApplyToAllText',
          isVisible: () => true,
          value: false,
        },
        {
          text: 'Add Text',
          key: 'addText',
          targetKey: 'isApplyToAllAddTextField',
          applyToAllKey: 'add_text_field',
          isVisible: () => true,
          value: false,
        },
        {
          text: 'Color',
          key: 'color',
          targetKey: 'isApplyToAllColor',
          applyToAllKey: 'fontColor',
          isVisible: () => this.isColorSelector,
          value: false,
        },
        {
          text: 'Font',
          key: 'font',
          targetKey: 'isApplyToAllFont',
          applyToAllKey: 'fontFamily',
          isVisible: () => this.isFontSelector,
          value: false,
        },
        {
          text: 'Size',
          key: 'size',
          targetKey: 'isApplyToAllSize',
          applyToAllKey: 'fontSize',
          isVisible: () => true,
          value: false,
        },
        {
          text: '% Size',
          key: 'sizePercent',
          targetKey: 'isApplyToAllSizePercent',
          applyToAllKey: 'fontSizePercent',
          isVisible: () => true,
          value: false,
        },
        {
          text: 'Alignment',
          key: 'alignment',
          targetKey: 'isApplyToAllAlignment',
          applyToAllKey: 'textAlignment',
          isVisible: () => this.isAlignmentSelector,
          value: false,
        },
        {
          text: 'Spacing',
          key: 'spacing',
          targetKey: 'isApplyToAllSpacing',
          applyToAllKey: 'textSpacing',
          isVisible: () => true,
          value: false,
        },
        {
          text: 'Line Height',
          key: 'leading',
          targetKey: 'isApplyToAllSpacing',
          applyToAllKey: 'lineHeight',
          isVisible: () => true,
          value: false,
        },
        {
          text: 'Position',
          key: 'position',
          targetKey: 'isApplyToAllPosition',
          isVisible: () => true,
          value: false,
        },
        {
          text: 'Character limit',
          key: 'maxChars',
          targetKey: 'isApplyToAllMaxChars',
          isVisible: () => true,
          value: false,
        },
        {
          text: 'Delete Text',
          key: 'deleteText',
          targetKey: 'isApplyToAllDeleteText',
          isVisible: () => true,
          value: false,
        }
      ],
      selectedProperties: [],
    };
  },
  computed: {
    getProperties() {
      return this.properties.filter(property => property.isVisible());
    }
  },
  mounted() {
    this.setPropertiesValues();
  },
  methods: {
    setPropertiesValues() {
      this.properties = this.properties.map((property) => {
        return {
          ...property,
          value: !!window?.applyToPropertiesListValues?.[property.targetKey],
        }
      });

      this.onInput();
    },
    onChangeProperties(property) {
      if (property.value) {
        if (!this.selectedProperties.some((p) => p.key === property.key)) {
          this.selectedProperties.push(property);
        }
      } else {
        this.selectedProperties = this.selectedProperties.filter((p) => p.key !== property.key);
      }
    },
    onChange(key, value) {
      this.$emit('change', key, value);
    },
    onInput() {
      const selectedPropertyKeys = this.properties.reduce((acc, { applyToAllKey, key, value }) => {

        if (value) {
          acc.push(applyToAllKey || key);
        }

        return acc;
      }, []);

      this.$emit('input', selectedPropertyKeys);
    },
    apply() {
      this.selectedProperties.forEach(property => {
        this.onChange(property.key, property.value);
      })
      this.$refs.propertiesDropdown.hide();
    },
    resetProperties() {
      this.properties.forEach(property => {
        property.value = false;
      });
      this.selectedProperties = [];
    }
  }
}
</script>

<style lang="scss">
.select-properties-dropdown ul {
  min-width: 11rem;
}
</style>
